import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';

export function getInsightSetIndustries(insightSetId, isAllocatedTo = true, excludeArchived = false) {
  return function(dispatch, getState) {
    const endpoint = '/industries';
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        isAllocatedTo,
        excludeArchived,
        insightSetId
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        if (isAllocatedTo) {
          dispatch(updateCurrentInsightSetAllocatedIndustries(response.data.industries));
        } else {
          dispatch(updateCurrentInsightSetUnallocatedIndustries(response.data.industries));
        }
      },
      error => dispatch(APIError(error, 'Error getting currentInsightSet Industries'))
    );
  }
}

export function updateCurrentInsightSetAllocatedIndustries(industries) {
  return {
    type: 'UPDATE_CURRENT_INSIGHTSET_ALLOCATED_INDUSTRIES',
    industries
  }
}

export function updateCurrentInsightSetUnallocatedIndustries(industries) {
  return {
    type: 'UPDATE_CURRENT_INSIGHTSET_UNALLOCATED_INDUSTRIES',
    industries
  }
}

export function addIndustryToInsightSet(insightSetId, industryId) {
  return function(dispatch, getState) {
    const endpoint = '/insightset/membership/industry';
    const options = {
      method: "POST",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: {
        industryId,
        insightSetId
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        // update both allocated and unallocated orgs
        dispatch(getInsightSetIndustries(insightSetId, true));
        dispatch(getInsightSetIndustries(insightSetId, false));
        return response;
      },
      error => dispatch(APIError(error, 'Error adding industry to currentInsightSet'))
    );
  }
}

export function removeIndustryFromInsightSet(insightSetId, industry) {
  return function(dispatch, getState) {
    const endpoint = `/insightset/membership/industry/${industry.membershipId}`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: { isArchived: true }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        // update both allocated and unallocated orgs
        dispatch(getInsightSetIndustries(insightSetId, true));
        dispatch(getInsightSetIndustries(insightSetId, false));
        return response;
      },
      error => dispatch(APIError(error, 'Error removing industry from currentInsightSet'))
    );
  }
}


// WEBPACK FOOTER //
// ./src/actions/insightSets/industryCreators.js